/*global
gsap,
ScrollTrigger,
Splide,
Swiper,
Fancybox,
SplitText,
jQuery
 */
/*eslint no-undef: "error"*/
/*eslint-env browser*/

// Make jQuery available if needed
const $j = jQuery.noConflict();

//// Site functions ////

function burgerMenu() {

    const navOpen = document.querySelector("#nav-open");
    const navContainer = document.querySelector("#nav-mobile");
    const burger = document.querySelector("#nav-icon");
    const menuItems = document.querySelectorAll("#menu-main__mobile>li");
    const mobMenuFooter = document.querySelector(".mobile-navbar__footer-wrap");
    const siteHeader = document.querySelector("#site-header");

    navOpen.addEventListener("click", function () {
        if (!navOpen.classList.contains('nav-open')) {

            gsap.to(navContainer, {
                display: "block"
            });

            gsap.to(navContainer, {
                autoAlpha: 1
            });

            gsap.from(menuItems, {
                autoAlpha: 0,
                yPercent: 100,
                ease: "power1.out",
                stagger: 0.05
            });

            gsap.from(mobMenuFooter, {
                autoAlpha: 0,
                yPercent: 100,
                ease: "power1.out",
                stagger: 0.05,
                delay: 0.3
            });

            document.documentElement.classList.add("noscroll");
            document.querySelector(".navbar-brand").classList.add("menu-open");
            navOpen.classList.add("nav-open");
            burger.classList.add("open");
            siteHeader.classList.add("nav-open");

        } else {
            gsap.to(navContainer, {
                autoAlpha: 0
            });
            gsap.to(navContainer, {
                display: "none"
            });
            document.documentElement.classList.remove("noscroll");
            document.querySelector(".navbar-brand").classList.remove("menu-open");
            navOpen.classList.remove("nav-open");
            burger.classList.remove("open");
            siteHeader.classList.remove("nav-open");
        }
    });

}

// Hide me show me header
function headerHideShow() {
    let didScroll;
    let lastScrollTop = 0;

    const navbar = document.querySelector("#site-header");

    const delta = 5;

    const navbarHeight = navbar.offsetHeight;

    window.addEventListener("scroll", () => {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            4
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        let st = window.pageYOffset;

        if (Math.abs(lastScrollTop - st) <= delta) return;

        if (st > lastScrollTop && st > (navbarHeight * 2)) {
            // Scroll Down
            navbar.classList.remove("nav-down");
            navbar.classList.add("nav-up");
        } else {
            // Scroll Up
            if (st + window.innerHeight < document.body.clientHeight) {
                navbar.classList.remove("nav-up");
                navbar.classList.add("nav-down");
            }
        }

        lastScrollTop = st;
    }

    // Change header on scroll
    function navScroll() {
        let $sticky = $j('#site-header'),
            $scroll = $j(window).scrollTop();

        if ($scroll > navbarHeight) {
            if (!$sticky.hasClass('scrolled')) {
                $sticky.addClass('scrolled');
            }
        } else {
            $sticky.removeClass('scrolled');
        }
    }
    navScroll();
    $j(window).on('scroll resize', navScroll);

}

function navDesktop() {
    let $menuItem = $j("#menu-main__desktop > li.menu-item-has-children > a");
    let $subMenu = $j("#menu-main__desktop > li.menu-item-has-children > ul.sub-menu");

    $menuItem.on("click", function () {
        $j(this).toggleClass("active");
        $j(this).siblings($subMenu).fadeToggle();
        $j(this).parent().siblings(".menu-item-has-children").find($subMenu).fadeOut();
        $j(this).parent().siblings(".menu-item-has-children").children($menuItem).removeClass("active");
    });

    $j(document).click(function (event) {
        var $target = $j(event.target);
        if (!$target.closest($menuItem).length &&
            !$target.closest($subMenu).length &&
            $subMenu.is(":visible")) {
            $subMenu.fadeOut();
            $menuItem.removeClass("active");
        }
    });

}

function navMobile() {
    let $menuItem = $j("#menu-main__mobile > li.menu-item-has-children > a");
    let $subMenu = $j("#menu-main__mobile > li.menu-item-has-children > ul.sub-menu");

    $menuItem.on("click", function () {
        $j(this).toggleClass("active");
        $j(this).siblings($subMenu).fadeToggle();
        $j(this).parent().siblings(".menu-item-has-children").find($subMenu).fadeOut();
        $j(this).parent().siblings(".menu-item-has-children").children($menuItem).removeClass("active");
    });

    $j(document).click(function (event) {
        var $target = $j(event.target);
        if (!$target.closest($menuItem).length &&
            !$target.closest($subMenu).length &&
            $subMenu.is(":visible")) {
            $subMenu.fadeOut();
            $menuItem.removeClass("active");
        }
    });

}

// Smooth scroll
function smoothScroll() {
    const stickyAnchors = $j('.flx-anchor-links').outerHeight();
    const links = document.querySelectorAll("a[href*='#']:not([href='#']):not([href*='valiant#']):not([href='#0'])");

    for (const link of links) {
        link.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
        e.preventDefault();
        const href = this.getAttribute("href");
        const offsetTop = document.querySelector(href).offsetTop;

        if (stickyAnchors) {

            scroll({
                top: offsetTop - stickyAnchors + 2,
                behavior: "smooth"
            });

        } else {

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });

        }

    }

}

function anchorHighlight() {

    const anchors = $j(".flx-anchor");
    const anchorsNextEl = $j(anchors).next();
    const anchorDestinations = gsap.utils.toArray(anchorsNextEl);

    if (typeof (anchorDestinations) != 'undefined' && anchorDestinations != null) {

        const stickyNavsHeight = $j('.flx-anchor-links').outerHeight();

        anchorDestinations.forEach((anchorDestination) => {

            const prevEl = $j(anchorDestination).prev();
            const idOfElement = $j(prevEl).attr("id");
            const anchorStickyLink = $j('a[href^="#' + idOfElement + '"]');

            ScrollTrigger.create({
                trigger: anchorDestination,
                start: () => "top " + stickyNavsHeight,
                end: () => "bottom " + stickyNavsHeight,
                onEnter: () => $j(anchorStickyLink).addClass('active'),
                onLeave: () => $j(anchorStickyLink).removeClass('active'),
                onEnterBack: () => $j(anchorStickyLink).addClass('active'),
                onLeaveBack: () => $j(anchorStickyLink).removeClass('active')
            });

        });

    }

}

// GSAP animations

// Animate on scroll (GSAP)

function gsapAnimateScroll() {
    const faders = gsap.utils.toArray("[data-vas='fade']");

    if (typeof (faders) != 'undefined' && faders != null) {

        faders.forEach((fader) => {

            gsap.set(fader, {
                autoAlpha: 0
            });

            // NB data-delay value must be in seconds, so it would be 0.2 for the equivalent "200" AOS value which is in milliseconds
            let faderDelay;

            if (fader.hasAttribute("data-vas-delay")) {
                faderDelay = fader.getAttribute("data-vas-delay");
            } else {
                faderDelay = 0;
            }

            ScrollTrigger.create({
                trigger: fader,
                start: "top bottom",
                markers: false,
                onEnter: () =>
                    gsap.to(fader, {
                        autoAlpha: 1,
                        duration: 1,
                        delay: faderDelay,
                        overwrite: true
                    }),
                onEnterBack: () =>
                    gsap.to(fader, {
                        autoAlpha: 1,
                        duration: 1,
                        overwrite: true
                    }),
                onLeaveBack: () =>
                    gsap.to(fader, {
                        autoAlpha: 0,
                        overwrite: true
                    })
            });
        });

    }

    // Slide up
    const fadersSU = gsap.utils.toArray("[data-vas='fade-up']");

    if (typeof (fadersSU) != 'undefined' && fadersSU != null) {

        fadersSU.forEach((faderSU) => {

            gsap.set(faderSU, {
                y: 50,
                autoAlpha: 0
            });

            // NB data-delay value must be in seconds, so it would be 0.2 for the equivalent "200" AOS value which is in milliseconds
            let faderDelay;

            if (faderSU.hasAttribute("data-vas-delay")) {
                faderDelay = faderSU.getAttribute("data-vas-delay");
            } else {
                faderDelay = 0.1;
            }

            ScrollTrigger.create({
                trigger: faderSU,
                start: "top bottom",
                markers: false,

                onEnter: () =>
                    gsap.to(faderSU, {
                        y: 0,
                        autoAlpha: 1,
                        duration: 0.5,
                        delay: faderDelay,
                        overwrite: true,
                        ease: "power3"
                    }),

                onLeaveBack: () =>
                    gsap.to(faderSU, {
                        y: 50,
                        autoAlpha: 0,
                        duration: 0.5,
                        overwrite: true
                    })

            });

        });

    }

}

// function heroParallax() {

//     const hero = document.querySelector(".hero-parallax");

//     if (typeof (hero) != 'undefined' && hero != null) {

//         gsap.to(hero, {
//             y: 450,
//             scale: 1.04,
//             scrollTrigger: {
//                 trigger: hero,
//                 start: "top",
//                 scrub: true
//             }
//         });

//     }

// }

function headerStdParallax() {

    const stdHead = document.querySelector(".header-std-parallax");

    if (typeof (stdHead) != 'undefined' && stdHead != null) {

        gsap.to(stdHead, {
            y: 180,
            scrollTrigger: {
                trigger: stdHead,
                start: "top",
                scrub: true
            }
        });

    }

}

function imageParallax() {

    // const images = document.querySelectAll(".image-parallax");
    let images = gsap.utils.toArray('.image-parallax');

    images.forEach((image) => {

        if (typeof (image) != 'undefined' && image != null) {

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: image,
                    scrub: true,
                    pin: false,
                    start: "top bottom",
                    end: "bottom top"
                }
            });

            tl.fromTo(image, {
                yPercent: -20,
                scale: 1.2,
                ease: 'none'
            }, {
                yPercent: 20,
                ease: 'none'
            });

        }

    });

}

function featImageParallax() {

    // const images = document.querySelectAll(".image-parallax");
    let images = gsap.utils.toArray('.feat-image-parallax');

    images.forEach((image) => {

        if (typeof (image) != 'undefined' && image != null) {

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: image,
                    scrub: true,
                    pin: false,
                    start: "top bottom",
                    end: "bottom top"
                }
            });

            tl.fromTo(image, {
                yPercent: -20,
                // scale: 1.2,
                ease: 'none'
            }, {
                yPercent: 20,
                ease: 'none'
            });

        }

    });

}

// Swipers

function swiperHero() {
    const heroSwiper = new Swiper('.hero-swiper', {
        effect: "fade",
        speed: 800,
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">0' + (index + 1) + "<div class='line'><span class='progress'></span></div></span>";
            }
        },
        // other parameters
        on: {
            init: function () {
                // do something
                gsapInitsplit();
            }
        }
    });

    heroSwiper.on('beforeTransitionStart', function () {
        gsapHero();
        console.log('swiper change');
    });

    // heroSwiper.on('init', function () {
    //     gsapInitsplit();
    //     console.log('swiper init');
    // });
}

function swiperTestimonial() {
    new Swiper('.testimonial-swiper', {

        effect: "fade",
        fadeEffect: { 
            crossFade: true 
        },
        speed: 3000,
        // slidesPerView: 1,
        autoplay: {
            delay: 8000
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">0' + (index + 1) + "<div class='line'><span class='progress'></span></div></span>";
            }
        }
    });
}

// function swiperTestimonial() {
//     const slider = document.querySelector(".testimonial-swipe");

//     if (typeof (slider) != 'undefined' && slider != null) {

//         const splide = new Splide(slider, {
//             type: 'loop',
//             focus: 'center',
//             autoWidth: true,
//             rewind: true,
//             updateOnMove: true,
//             arrows: true,
//             pagination: true,
//             autoplay: true,
//             interval: 3000,
//             speed: 800,
//             pauseOnHover: false
//         });

//         splide.mount();


//     } else {
//         return;
//     }
// }

function swiperLogos() {
    new Swiper('.logos-swiper', {
        // spaceBetween: '15%',
        spaceBetween: '5%',
        centeredSlides: true,
        speed: 10000,
        autoplay: {
            delay: 1
        },
        loop: true,
        slidesPerView: 'auto',
        allowTouchMove: false,
        disableOnInteraction: true
    });
}

function swiperGallery() {
    new Swiper('.gallery-swiper', {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 30,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    });
}

//// Flexible content functions ////

// Accordion
function flxAccordion() {
    const accordionBlocks = document.querySelectorAll(".flx-accordion");

    accordionBlocks.forEach((accordionBlock) => {

        const accordions = accordionBlock.querySelectorAll(".flx-accordion__row");
        const allContent = accordionBlock.querySelectorAll(".flx-accordion__row-content");

        $j(allContent).hide();

        if (typeof (accordions) != 'undefined' && accordions != null) {

            const openAccordion = (accordion) => {
                const heading = accordion.querySelector(".flx-accordion__row-heading");
                const content = accordion.querySelector(".flx-accordion__row-content");
                const icon = accordion.querySelector(".flx-accordion__row-icon");
                heading.classList.add("active");
                content.classList.add("open");
                icon.classList.add("active");
                $j(content)
                    .css('opacity', 0)
                    .slideDown('fast')
                    .animate(
                        { opacity: 1 },
                        { queue: false, duration: 'fast' }
                    );
                // content.style.maxHeight = content.scrollHeight + "px";
            };

            const closeAccordion = (accordion) => {
                const heading = accordion.querySelector(".flx-accordion__row-heading");
                const content = accordion.querySelector(".flx-accordion__row-content");
                const icon = accordion.querySelector(".flx-accordion__row-icon");
                heading.classList.remove("active");
                content.classList.remove("open");
                icon.classList.remove("active");
                $j(content)
                    .css('opacity', 1)
                    .slideUp('fast')
                    .animate(
                        { opacity: 0 },
                        { queue: false, duration: 'fast' }
                    );
                // content.style.maxHeight = null;
            };

            accordions.forEach((accordion) => {
                const intro = accordion.querySelector(".flx-accordion__row-heading");
                // const icon = accordion.querySelector(".flx-accordion__row-icon");
                const content = accordion.querySelector(".flx-accordion__row-content");

                intro.onclick = () => {
                    if (content.classList.contains("open")) {
                        closeAccordion(accordion);
                    } else {
                        accordions.forEach((accordion) => closeAccordion(accordion));
                        openAccordion(accordion);
                    }
                };

                // icon.onclick = () => {
                //     if (content.classList.contains("open")) {
                //         closeAccordion(accordion);
                //     } else {
                //         accordions.forEach((accordion) => closeAccordion(accordion));
                //         openAccordion(accordion);
                //     }
                // };
            });


            const panels = accordionBlock.querySelectorAll(".more-accordions-reveal");

            if ($j(panels).length > 0) {

                $j(panels).hide();

                if (typeof (panels) != 'undefined' && panels != null) {


                    const openPanel = (panel) => {
                        panel.classList.add("open");

                        $j(panel)
                            .css('opacity', 0)
                            .slideDown('fast')
                            .animate(
                                { opacity: 1 },
                                { queue: false, duration: 'fast' }
                            );
                    };

                    const closePanel = (panel) => {
                        panel.classList.remove("open");
                        $j(panel)
                            .css('opacity', 1)
                            .slideUp('fast')
                            .animate(
                                { opacity: 0 },
                                { queue: false, duration: 'fast' }
                            );
                    };

                    panels.forEach((panel) => {

                        const trigger = accordionBlock.querySelector(".btn-reveal");
                        const trigerSpan = accordionBlock.querySelector(".btn-reveal>span");

                        trigger.onclick = (e) => {
                            e.preventDefault();

                            setTimeout(() => {
                                ScrollTrigger.refresh();
                            }, 300);

                            if (panel.classList.contains("open")) {
                                closePanel(panel);
                                trigger.classList.remove("open");
                                trigerSpan.textContent = "View more";
                            } else {
                                trigger.classList.add("open");
                                panels.forEach((panel) => closePanel(panel));
                                openPanel(panel);
                                trigerSpan.textContent = "View less";
                            }
                        };

                    });

                } else {
                    return;
                }

            }

        } else {
            return;
        }

    });
}

// FAQs
function flxFaqs() {
    const faqsBlocks = document.querySelectorAll(".flx-faqs");

    faqsBlocks.forEach((faqsBlock) => {

        const faqs = faqsBlock.querySelectorAll(".flx-faq__row");
        const allFaqs = faqsBlock.querySelectorAll(".flx-faq__row-content");

        $j(allFaqs).hide();

        if (typeof (faqs) != 'undefined' && faqs != null) {

            const openfaq = (faq) => {
                const heading = faq.querySelector(".flx-faq__row-heading");
                const content = faq.querySelector(".flx-faq__row-content");
                const icon = faq.querySelector(".flx-faq__row-icon");
                heading.classList.add("active");
                content.classList.add("open");
                icon.classList.add("active");
                $j(content)
                    .css('opacity', 0)
                    .slideDown('fast')
                    .animate(
                        { opacity: 1 },
                        { queue: false, duration: 'fast' }
                    );
            };

            const closefaq = (faq) => {
                const heading = faq.querySelector(".flx-faq__row-heading");
                const content = faq.querySelector(".flx-faq__row-content");
                const icon = faq.querySelector(".flx-faq__row-icon");
                heading.classList.remove("active");
                content.classList.remove("open");
                icon.classList.remove("active");
                $j(content)
                    .css('opacity', 1)
                    .slideUp('fast')
                    .animate(
                        { opacity: 0 },
                        { queue: false, duration: 'fast' }
                    );
            };

            faqs.forEach((faq) => {
                const intro = faq.querySelector(".flx-faq__row-heading");
                // const icon = faq.querySelector(".flx-faq__row-icon");
                const content = faq.querySelector(".flx-faq__row-content");

                intro.onclick = () => {
                    if (content.classList.contains("open")) {
                        closefaq(faq);
                    } else {
                        faqs.forEach((faq) => closefaq(faq));
                        openfaq(faq);
                    }
                };
            });

        } else {
            return;
        }

    });
}

// Service block: video
function playServiceVideo() {

    if ($j('.flx-services').length > 0) {

        let videos = gsap.utils.toArray('.service-video');

        videos.forEach((video) => {

            let player = video.querySelector("video");

            const restartVideo = (el) => {
                el.pause();
                el.currentTime = 0;
            };

            ScrollTrigger.create({
                trigger: player,
                start: "top bottom",
                end: "bottom top",
                markers: false,

                onEnter: () => player.play(),
                onEnterBack: () => player.play(),
                onLeave: () => restartVideo(player),
                onLeaveBack: () => restartVideo(player)

            });

        });

    }

}

// Tabs block
function flxTabs() {

    if ($j('.flx-tabs').length > 0) {

        const firstTab = document.querySelector('.tabs__content-panel:first-child');

        $j(firstTab).show().addClass('active');

        $j('[data-tab]').on('click', function (e) {
            $j(this).addClass('active').siblings('[data-tab]').removeClass('active')
            $j('.tabs__content-panel[data-content=' + $j(this).data('tab') + ']').show().addClass('active').siblings('[data-content]').hide().removeClass('active')
            e.preventDefault()
        })

    }

}

// Latest projects slider
function flxLatestProjects() {
    const slider = document.querySelector(".flx-latest-projects__feed");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'loop',
            updateOnMove: true,
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 7000,
            speed: 800
        });

        splide.mount();

        // Move arrows
        $j(".flx-latest-projects__arrows").appendTo("#flx-latest-projects__arrows");

    } else {
        return;
    }
}

function flxGallerySlider() {
    const slider = document.querySelector(".gallery-slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'loop',
            focus: 'center',
            autoWidth: true,
            rewind: true,
            updateOnMove: true,
            arrows: true,
            pagination: true,
            autoplay: true,
            interval: 3000,
            speed: 800,
            pauseOnHover: false,
            gap: '1.9rem',
            breakpoints: {
                767: {
                    autoWidth: false,
                    perPage: 2
                }
            }
        });

        splide.mount();


    } else {
        return;
    }
}

// Testimonial slider
// function flxTestimonialSlider() {
//     const slider = document.querySelector(".flx-testfeed__slider");

//     if (typeof (slider) != 'undefined' && slider != null) {

//         const splide = new Splide(slider, {
//             type: 'fade',
//             updateOnMove: true,
//             arrows: false,
//             pagination: true,
//             rewind: true,
//             autoplay: true,
//             autoHeight: false,
//             pauseOnHover: true,
//             interval: 5000,
//             speed: 1100
//         });

//         splide.mount();

//         // Move pagination
//         $j(".flx-testfeed__pagination").appendTo("#flx-testfeed-dots");

//     } else {
//         return;
//     }
// }

// Logo slider
// function flxLogoSlider() {
//     const slider = document.querySelector(".flx-logos__slider");

//     if (typeof (slider) != 'undefined' && slider != null) {

//         const splide = new Splide(slider, {
//             type: 'loop',
//             drag: 'free',
//             snap: true,
//             arrows: false,
//             gap: "3rem",
//             perPage: 4,
//             breakpoints: {
//                 991: {
//                     perPage: 3
//                 },
//                 600: {
//                     perPage: 2
//                 }
//             }
//         });

//         splide.mount();

//     } else {
//         return;
//     }
// }

// Image slider
function flxImageSlider() {
    const slider = document.querySelector(".flx-img-slider__slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'loop',
            updateOnMove: true,
            arrows: true,
            pagination: false,
            gap: '5rem',
            autoplay: true,
            interval: 7000,
            speed: 800,
            breakpoints: {
                991: {
                    gap: '2.5rem'
                }
            }
        });

        splide.mount();

    } else {
        return;
    }
}

// Before/After slider
function flxBeforeAfterSlider() {

    let sliders = gsap.utils.toArray('.beforeafter__slider');

    sliders.forEach((slider) => {

        if (typeof (slider) != 'undefined' && slider != null) {

            var main = new Splide(slider, {
                type: 'fade',
                arrows: false,
                pagination: false,
                autoplay: false,
                speed: 300,
                pauseOnHover: false,
                rewind: true
            });

            main.mount();

            const triggerSlide = slider.querySelector("#beforeafter-toggle>.switch-input");
            $j(triggerSlide).click(function () {
                main.go('>');
            });

            var switchLabel = slider.querySelector('.switch-label');
            var pseudoBeforeWidth = window.getComputedStyle(switchLabel, ':before').width.replace("px", "");
            var pseudoAfterWidth = window.getComputedStyle(switchLabel, ':after').width.replace("px", "");

            const labelWidths = [pseudoBeforeWidth, pseudoAfterWidth];
            // const labelWidths = [parseInt(pseudoBeforeWidth, 10), parseInt(pseudoAfterWidth, 10)];
            const labelMaxWidth = labelWidths.reduce((a, b) => Math.max(a, b), -Infinity);

            console.log(Math.round(labelMaxWidth * 1) / 1);

            const baToggle = slider.querySelector("#beforeafter-toggle");
            console.log(baToggle);
            baToggle.style.width = labelMaxWidth + 26 + 'px';

        } else {
            return;
        }

    });

}

// Vanilla Modal
function vanillaModal() {
    const modals = document.querySelectorAll("[data-modal]");
    const body = document.documentElement;

    modals.forEach(function (trigger) {
        const modal = document.getElementById(trigger.dataset.modal);
        const exits = modal.querySelectorAll(".modal-exit");

        trigger.addEventListener("click", function (event) {
            event.preventDefault();
            modal.classList.add("open");
            body.classList.add("noscroll");
            exits.forEach(function (exit) {
                exit.addEventListener("click", function (event) {
                    event.preventDefault();
                    modal.classList.remove("open");
                    body.classList.remove("noscroll");
                });
            });
        });
    });

}

function flxQuicklinksImages() {
    const quicklinksContent = document.querySelectorAll(".flx-quicklinks-images__content-wrap");
    const quicklinksContentFirst = document.querySelectorAll(".flx-quicklinks-images__content-wrap:first-child");
    const quicklinkLinks = document.querySelectorAll(".flx-quicklinks-images__quicklinks-list>ul>li.quicklink>a");
    const quicklinksLinkFirst = document.querySelectorAll(".flx-quicklinks-images__quicklinks-list>ul>li.quicklink:first-child>a");

    if (typeof (quicklinksContent) != 'undefined' && quicklinksContent != null) {

        gsap.set(quicklinksContent, {
            autoAlpha: 0
        })

        gsap.set(quicklinksContentFirst, {
            autoAlpha: 1
        })

        $j(quicklinksLinkFirst).addClass('active');

        quicklinkLinks.forEach((quicklinkLink) => {

            quicklinkLink.addEventListener("mouseover", function (e) {

                $j(quicklinkLink).addClass('active').parent().siblings().children('[data-hover-tab]').removeClass('active')
                const linkedpanel = $j('.flx-quicklinks-images__content-wrap[data-hover-content=' + $j(quicklinkLink).data('hover-tab') + ']')
                const otherPanels = $j(linkedpanel).siblings();

                console.log(linkedpanel);

                gsap.set(linkedpanel, {
                    autoAlpha: 1
                    // display: 'block'
                })

                gsap.set(otherPanels, {
                    autoAlpha: 0
                    // display: 'none'
                })

                e.preventDefault();

            });

        });

    }

}

// Quicklinks slider
function flxQlsSlider() {
    const slider = document.querySelector(".flx-quicklinks-images__slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'fade',
            updateOnMove: true,
            pagination: false,
            arrows: true,
            rewind: true,
            autoplay: true,
            interval: 6000,
            speed: 1500,
            gap: '2.5rem',
            perPage: 1
        });

        splide.mount();

        // Move arrows
        // $j(".flx-markets__arrows").appendTo("#flx-quicklinks-images__arrows");

    } else {
        return;
    }
}

// Case study slider
function flxCsSlider() {
    const slider = document.querySelector(".flx-case-study-slider__slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'fade',
            updateOnMove: true,
            pagination: false,
            pauseOnHover: false,
            arrows: true,
            rewind: true,
            autoplay: true,
            interval: 6000,
            speed: 1500,
            perPage: 1
        });

        splide.mount();

        // Move arrows
        // $j(".flx-markets__arrows").appendTo("#flx-quicklinks-images__arrows");

    } else {
        return;
    }
}

// Team slider
function flxTeamSlider() {
    const slider = document.querySelector(".flx-team-slider__slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'loop',
            pagination: true,
            pauseOnHover: true,
            arrows: false,
            rewind: true,
            autoplay: true,
            interval: 6000,
            speed: 1500,
            perPage: 1,
            gap: '2.5rem'
        });

        splide.on('pagination:mounted', function (data) {
            // You can add your class to the UL element
            data.list.classList.add('flx-team-slider__pagination');

            // `items` contains all dot items
            data.items.forEach(function (item) {
                item.button.textContent = String(item.page + 1);
            });


            // Move pagination
            $j(".flx-team-slider__pagination").appendTo("#flx-team-slider__pagination");

        });

        splide.mount();

    } else {
        return;
    }
}

// Journal slider
function flxJournalHeaderSlider() {
    const slider = document.querySelector(".header-journal-listing__slider ");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'fade',
            pagination: true,
            pauseOnHover: true,
            arrows: false,
            rewind: true,
            autoplay: true,
            interval: 6000,
            speed: 1500,
            perPage: 1,
            gap: '2.5rem'
        });

        splide.on('pagination:mounted', function (data) {
            // You can add your class to the UL element
            data.list.classList.add('header-journal-listing__pagination');

            // `items` contains all dot items
            data.items.forEach(function (item) {
                item.button.textContent = String(item.page + 1);
            });

        });


        // Move pagination
        $j(".header-journal-listing__pagination").appendTo("#header-journal-listing__pagination");

        // });

        splide.mount();

    } else {
        return;
    }
}

// Journal slider
function flxJournalSlider() {
    const slider = document.querySelector(".flx-journal-slider__slider");

    if (typeof (slider) != 'undefined' && slider != null) {

        const splide = new Splide(slider, {
            type: 'loop',
            updateOnMove: true,
            pagination: false,
            pauseOnHover: false,
            arrows: true,
            rewind: true,
            autoplay: true,
            interval: 6000,
            speed: 1500,
            perPage: 3,
            gap: '2.5rem',
            breakpoints: {
                1200: {
                    perPage: 2
                },
                767: {
                    perPage: 1
                }
            }
        });

        splide.mount();

        // Move arrows
        $j(".flx-journal-slider__arrows").appendTo("#flx-journal-slider__arrows");

    } else {
        return;
    }
}

// Case study reveal
function casestudyReveal() {

    if ($j('.case-study-single__intro-content__reveal').length > 0) {

        const panels = document.querySelectorAll(".case-study-single__intro-content__reveal");

        $j(panels).hide();

        if (typeof (panels) != 'undefined' && panels != null) {


            const openPanel = (panel) => {
                panel.classList.add("open");

                $j(panel)
                    .css('opacity', 0)
                    .slideDown('fast')
                    .animate(
                        { opacity: 1 },
                        { queue: false, duration: 'fast' }
                    );
            };

            const closePanel = (panel) => {
                panel.classList.remove("open");
                $j(panel)
                    .css('opacity', 1)
                    .slideUp('fast')
                    .animate(
                        { opacity: 0 },
                        { queue: false, duration: 'fast' }
                    );
            };

            panels.forEach((panel) => {

                const trigger = document.querySelector(".btn-reveal");
                const trigerSpan = document.querySelector(".btn-reveal>span");

                trigger.onclick = (e) => {
                    e.preventDefault();

                    setTimeout(() => {
                        ScrollTrigger.refresh();
                    }, 300);

                    if (panel.classList.contains("open")) {
                        closePanel(panel);
                        trigger.classList.remove("open");
                        trigerSpan.textContent = "Read more";
                    } else {
                        trigger.classList.add("open");
                        panels.forEach((panel) => closePanel(panel));
                        openPanel(panel);
                        trigerSpan.textContent = "Read less";
                    }
                };

            });

        } else {
            return;
        }

    }

}

// Scrolling text
function flxScrollingText() {

    let scrollingTextItems = document.querySelectorAll(".scrolling-text");

    if (typeof (scrollingTextItems) != 'undefined' && scrollingTextItems != null) {

        scrollingTextItems.forEach((scrollingText) => {

            gsap.to(scrollingText, {
                xPercent: -100,
                duration: 35,
                ease: 'linear',
                repeat: -1
            });

        });

    }

    else {
        return;
    }

}

// Image/video banner
function playIBVideo() {

    if ($j('.flx-imagebanner').length > 0) {

        let videos = gsap.utils.toArray('.ib-video');

        videos.forEach((video) => {

            let player = video.querySelector("video");

            const restartVideo = (el) => {
                el.pause();
                el.currentTime = 0;
            };

            ScrollTrigger.create({
                trigger: player,
                start: "top bottom",
                end: "bottom top",
                markers: false,

                onEnter: () => player.play(),
                onLeaveBack: () => restartVideo(player)

            });

        });

    }

}

// Multimedia video
function playMMVideo() {

    if ($j('.flx-mm-block').length > 0) {

        let videos = gsap.utils.toArray('.mm-video');

        videos.forEach((video) => {

            let player = video.querySelector("video");

            const restartVideo = (el) => {
                el.pause();
                el.currentTime = 0;
            };

            ScrollTrigger.create({
                trigger: player,
                start: "top bottom",
                end: "bottom top",
                markers: false,

                onEnter: () => player.play(),
                onLeaveBack: () => restartVideo(player)

            });

        });

    }

}

// Meet the Makers video
function playMakersVideo() {

    if ($j('.flx-meet-the-makers').length > 0) {

        let videos = gsap.utils.toArray('.large-video');

        videos.forEach((video) => {

            let player = video.querySelector("video");

            const restartVideo = (el) => {
                el.pause();
                el.currentTime = 0;
            };

            ScrollTrigger.create({
                trigger: player,
                start: "top bottom",
                end: "bottom top",
                markers: false,

                onEnter: () => player.play(),
                onLeaveBack: () => restartVideo(player)

            });

        });

    }

}

// List block video
function playListblockVideo() {

    if ($j('.flx-list-block').length > 0) {

        let videos = gsap.utils.toArray('.flx-list-block__video');

        videos.forEach((video) => {

            let player = video.querySelector("video");

            const restartVideo = (el) => {
                el.pause();
                el.currentTime = 0;
            };

            ScrollTrigger.create({
                trigger: player,
                start: "top bottom",
                end: "bottom top",
                markers: false,

                onEnter: () => player.play(),
                onLeaveBack: () => restartVideo(player)

            });

        });

    }

}

// Image grid video
function flxImgGridVideo() {

    if ($j('.flx-img-grid').length > 0) {

        let videos = gsap.utils.toArray('.video');

        videos.forEach((video) => {

            let player = video.querySelector("video");

            const restartVideo = (el) => {
                el.pause();
                el.currentTime = 0;
            };

            ScrollTrigger.create({
                trigger: player,
                start: "top bottom",
                end: "bottom top",
                markers: false,

                onEnter: () => player.play(),
                onLeaveBack: () => restartVideo(player)

            });

        });

    }

}

// Project video
function playProjVideo() {

    if ($j('.projects-listing__video').length > 0) {

        let videos = gsap.utils.toArray('.projects-listing__video');

        videos.forEach((video) => {

            let player = video.querySelector("video");

            const restartVideo = (el) => {
                el.pause();
                el.currentTime = 0;
            };

            ScrollTrigger.create({
                trigger: player,
                start: "top bottom",
                end: "bottom top",
                markers: false,

                onEnter: () => player.play(),
                onLeave: () => restartVideo(player),
                onEnterBack: () => player.play(),
                onLeaveBack: () => restartVideo(player)

            });

        });

    }

    if ($j('.header-projects-single__video').length > 0) {

        let videos = gsap.utils.toArray('.header-projects-single__video');

        videos.forEach((video) => {

            let player = video.querySelector("video");

            const restartVideo = (el) => {
                el.pause();
                el.currentTime = 0;
            };

            ScrollTrigger.create({
                trigger: player,
                start: "top bottom",
                end: "bottom top",
                markers: false,

                onEnter: () => player.play(),
                onLeave: () => restartVideo(player),
                onEnterBack: () => player.play(),
                onLeaveBack: () => restartVideo(player)

            });

        });

    }

    if ($j('.project-video').length > 0) {

        let videos = gsap.utils.toArray('.project-video');

        videos.forEach((video) => {

            let player = video.querySelector("video");

            const restartVideo = (el) => {
                el.pause();
                el.currentTime = 0;
            };

            ScrollTrigger.create({
                trigger: player,
                start: "top bottom",
                end: "bottom top",
                markers: false,

                onEnter: () => player.play(),
                onLeave: () => restartVideo(player),
                onEnterBack: () => player.play(),
                onLeaveBack: () => restartVideo(player)

            });

        });

    }

}

// Sticky elements
// function flxStickyEl() {
//     if ($j('.sticky-element').length > 0) {
//         new Sticky('.sticky');
//     }
// }

// Animated logos
function flxLogos() {
    if ($j('.flx-logos').length > 0) {

        const logos = document.querySelector(".flx-logos__logo-grid");

        gsap.set(logos, {
            autoAlpha: 0
        });

        ScrollTrigger.create({
            trigger: logos,
            start: "top 80%",
            end: "bottom top",
            // markers: true,

            onEnter: () =>
                gsap.to(logos, {
                    autoAlpha: 1,
                    duration: 2,
                    overwrite: true
                }),
            onLeaveBack: () =>
                gsap.to(logos, {
                    autoAlpha: 0,
                    overwrite: true
                })

        });

    }
}

// Lottie files
function playLottie() {

    if ($j('.lottie-animation').length > 0) {

        let videos = gsap.utils.toArray('.lottie-trig');

        videos.forEach((video) => {

            let player = video.querySelector("lottie-player");

            gsap.to(player, {
                autoAlpha: 0
            });

            ScrollTrigger.create({
                trigger: player,
                start: "top 90%",
                end: "bottom 10%",
                markers: false,

                onEnter: () => {
                    gsap.to(player, {
                        autoAlpha: 1
                    })
                    player.seek(0);
                    player.play();
                },

                onLeave: () => {
                    player.pause();
                },

                onEnterBack: () => {
                    player.seek(0);
                    player.play();
                },

                onLeaveBack: () => {
                    gsap.to(player, {
                        autoAlpha: 0
                    })
                }
            });

        });

    }

}

// Fancybox
Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

function gsapHero() {

    const childSplit = new SplitText(".swiper-slide-active .text-reveal", {
        type: "lines",
        linesClass: "split-child"
    });

    new SplitText(".text-reveal", {
        type: "lines",
        linesClass: "split-line"
    });

    gsap.from(childSplit.lines, {
        duration: 1.5,
        yPercent: 100,
        delay: .3,
        ease: "power4",
        stagger: 0.1
    });

}

function gsapInitsplit() {

    const childSplit = new SplitText(".text-reveal", {
        type: "lines",
        linesClass: "split-child"
    });

    new SplitText(".text-reveal", {
        type: "lines",
        linesClass: "split-line"
    });

    gsap.from(childSplit.lines, {
        duration: 1.5,
        yPercent: 100,
        delay: 1.5,
        ease: "power4",
        stagger: 0.1
    });

}

// function textRevealScroll() {

//     const textgroup = gsap.utils.toArray(".text-reveal-scroll");

//     if (typeof (textgroup) != 'undefined' && textgroup != null) {

//         textgroup.forEach((text) => {

//             const childSplit = new SplitText("h2", {
//                 type: "lines",
//                 linesClass: "split-child"
//             });

//             new SplitText("h2", {
//                 type: "lines",
//                 linesClass: "split-line"
//             });

//             gsap.from(childSplit.lines, {
//                 duration: 1.5,
//                 yPercent: 100,
//                 delay: .3,
//                 ease: "power4",
//                 stagger: 0.1
//             });

//             ScrollTrigger.create({
//                 trigger: text,
//                 start: "top 90%",
//                 markers: false,
//                 onEnter: () =>
//                     gsap.to(childSplit.lines, {
//                         duration: 1.5,
//                         yPercent: 0,
//                         delay: textDelay,
//                         ease: "power4",
//                         stagger: 0.1
//                     })
//             });

//         });
    
//     }

// }

// function textRevealScroll() {

//     const textgroup = gsap.utils.toArray("[data-txt='reveal-scroll']");

//     if (typeof(textgroup) != 'undefined' && textgroup != null) {

//         textgroup.forEach((text) => {

//             // gsap.set(text, {
//             //     yPercent: 100
//             // }); 

//             let textDelay;

//             if (text.hasAttribute("data-txt-delay")) {
//                 textDelay = text.getAttribute("data-txt-delay");
//             } else {
//                 textDelay = 0;
//             }

//             const childSplit = new SplitText(text, {    
//                 type: "lines",
//                 linesClass: "split-child"
//             });

//             new SplitText(text, {
//                 type: "lines",
//                 linesClass: "split-parent"
//             });

//             gsap.set(childSplit.lines, {
//                 yPercent: 100
//             });

//             ScrollTrigger.create({
//                 trigger: text,
//                 start: "top 90%",
//                 markers: false,
//                 onEnter: () =>
//                     gsap.to(childSplit.lines, {
//                         duration: 1.5,
//                         yPercent: 0,
//                         delay: textDelay,
//                         ease: "power4",
//                         stagger: 0.1
//                     })
//             });           

//         });

//     }

// }


//// Utility functions ////

// DOM Ready

var DOMReady = function (callback) {
            if (
                document.readyState === "interactive" ||
                document.readyState === "complete"
            ) {
                callback();
            } else if (document.addEventListener) {
                document.addEventListener("DOMContentLoaded", callback());
            } else if (document.attachEvent) {
                document.attachEvent("onreadystatechange", function () {
                    if (document.readyState != "loading") {
                        callback();
                    }
                });
            }
        };


        //// Let's go! ////
        DOMReady(function () {

            headerHideShow();
            anchorHighlight();
            burgerMenu();
            navDesktop();
            navMobile();
            smoothScroll();

            // Swipers
            swiperHero();
            swiperTestimonial();
            swiperLogos();
            swiperGallery();

            headerStdParallax();
            imageParallax();
            featImageParallax();
            gsapAnimateScroll();
            // flxStickyEl();
            flxAccordion();
            flxFaqs();
            // flxLogoSlider();
            flxImageSlider();
            flxGallerySlider();
            // flxTestimonialSlider();
            flxBeforeAfterSlider();
            flxLatestProjects();
            flxTabs();
            casestudyReveal();
            playProjVideo();
            playMMVideo();
            flxScrollingText();
            playServiceVideo();
            flxLogos();
            playIBVideo();
            playLottie();
            vanillaModal();
            flxQuicklinksImages();
            flxQlsSlider();
            flxCsSlider();
            flxTeamSlider();
            flxJournalHeaderSlider();
            flxJournalSlider();
            flxImgGridVideo();
            playMakersVideo();
            playListblockVideo();
            // textRevealScroll();

            $j(document).on("sf:ajaxfinish", ".searchandfilter", function () {
                gsapAnimateScroll();
                playProjVideo();
            });

        });


        //// Preloader ///
        const preloader = document.querySelector("#page-preloader");

        document.addEventListener('DOMContentLoaded', function () {

            if (preloader.classList.contains("loaded")) {
                preloader.classList.remove("loaded");
            }
            setTimeout(function () {
                preloader.classList.add("loaded");
            }, 1300);

        });

